import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Container, Card, Grid, Tab, Dropdown} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {getDropdownOptions} from '../../../common/util/dropdown';
import WtsPositions from './positions';
import WtsSkills from './skills';
import WtsCoursesAreas from './coursesAreas';
import WtsCoursesStatus from './coursesStatus';
import WtsProfiles from './profiles';
import WtsDealer from './dealer';
import WtsAgency from './agencies';
import WtsParams from './params';
import './styles.scss';

const {
  navigateTo,
  getWtsDealer,
  getWtsAreas,
  changeWtsAreaSelected,
} = Actions;

const WtsCatalogs = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const {areas, areaSelected} = useSelector((state) => state.wtsAreas);
  const [activeTabIdx, setActiveTabIdx] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.WtsCatalogos, scopes.See) &&
     !hasAccessPermission(permissions, resources.WtsCatalogos, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(getWtsDealer());
    dispatch(getWtsAreas());
  }, []);

  const onTabChange = (e, val) => {
    e.preventDefault();
    setActiveTabIdx(val.activeIndex);
  };

  const onChangeWtsAreaSelected = (e, {value}) => {
    e.preventDefault();
    dispatch(changeWtsAreaSelected(areas.find((x) => x.id === value)));
  };

  return (
    <Container fluid>
      <Card raised fluid style={{'backgroundColor': 'transparent'}}>
        <div className='title-bar'>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <div className='title'>
                  <h2>Gestión de catálogos WTS</h2>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row textAlign='left'>
              <Grid.Column width={5}>
                <div className="ui fluid labeled input">
                  <div className="ui label label">Área de capacitación</div>
                  <Dropdown fluid selection labeled className='labeled-dropdown'
                    value={areaSelected?.id} onChange={(e, i) => onChangeWtsAreaSelected(e, i)}
                    options={getDropdownOptions(areas, 'id', 'description')} />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <Tab
          menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
          panes={
            [
              {'menuItem': 'CONCESIONARIO', 'render': () => <WtsDealer activeTab={activeTabIdx} />},
              {'menuItem': 'AGENCIAS', 'render': () => <WtsAgency activeTab={activeTabIdx} />},
              {'menuItem': 'AREAS', 'render': () => <WtsCoursesAreas activeTab={activeTabIdx} />},
              {'menuItem': 'CARGOS', 'render': () => <WtsPositions activeTab={activeTabIdx} />},
              {'menuItem': 'PERFILES', 'render': () => <WtsProfiles activeTab={activeTabIdx} />},
              {'menuItem': 'HABILIDADES', 'render': () => <WtsSkills activeTab={activeTabIdx} />},
              {'menuItem': 'ESTADOS CURSOS', 'render': () => <WtsCoursesStatus activeTab={activeTabIdx} />},
              {'menuItem': 'PARÁMETROS', 'render': () => <WtsParams activeTab={activeTabIdx} />},
            ]
          }
          activeIndex={activeTabIdx}
          onTabChange={(e, val) => onTabChange(e, val)} />
      </Card>
    </Container>
  );
};

export default WtsCatalogs;
